<template>
    <el-popover placement="bottom" :width="174" trigger="hover">
        <template #reference>
            <qrcodeButton />
        </template>
        <qrcodeComponents v-if="null != url" :url="url" :width="150" :height="150" />
    </el-popover>
</template>

<script setup>
    import qrcodeComponents from "@/components/shopopee/common/qrcodeComponents"
    import qrcodeButton from "@/components/shopopee/button/qrcodeButton"
    import { library } from '@fortawesome/fontawesome-svg-core'
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
    import {faQrcode} from '@fortawesome/free-solid-svg-icons'

    library.add(faQrcode)

    const props = defineProps(["url"])
</script>

<style scoped>
    .icon-btn {
        padding: 8px;
    }
</style>